import {Card} from './../types/Card';

export enum AccountType {
    CUSTOMER_BANK = 'CUSTOMER_BANK',
    CUSTOMER_CUSTODY = 'CUSTOMER_CUSTODY',
    CUSTOMER_CRYPTO = 'CUSTOMER_CRYPTO',
}
export function isAccountType($: any): $ is AccountType {
    return Object.values(AccountType).indexOf($) > -1;
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
    BLOCKED = 'BLOCKED',
}

export function isAccountStatus($: any): $ is AccountStatus {
    return Object.values(AccountStatus).indexOf($) > -1;
}

export enum AccountDetailType {
    BANK_GATEWAY = 'BANK_GATEWAY',
}
export enum AccountDetailStatus {
    INIT = 'INIT', // Empty

    APPROVAL = 'APPROVAL', // Waiting for Platform officer approve and 'Bank' provider assignation
    APPROVED = 'APPROVED', // Approved by Platform officer and default 'Bank' provider assigned
    GATEWAY_LINK_APPROVAL = 'GATEWAY_LINK_APPROVAL', // Waiting for external registration approval
    GATEWAY_LINK_REGISTERED = 'GATEWAY_LINK_REGISTERED', // External customer registered
    GATEWAY_LINK_CREATED = 'GATEWAY_LINK_CREATED', // IBAN created
}

export enum BoughtPackageStatus {
    NEW = 'NEW',
    COMPLETED = 'COMPLETED'
}

export enum TransactionChannelType {
    IBAN = 'IBAN',
    SWIFT = 'SWIFT',
    INTERNAL = 'INTERNAL',
    SEPA = 'SEPA',
    FPS = 'FPS',
    EXCHANGE = 'EXCHANGE',
}

export type ExternalProviderMetaDataRequisites = {
    bankName: string,
    bankAddress: string,
    accountHolderName: string,
    swift?: {
        swiftCode: string,
        intermediaryBank: {
            bankName: string,
            swiftCode: string,
            accountNumber: string
        }
    },
    sepa?: {
        bicCode: string
    },
    localPayment?: {
        accountNumber: string,
        sortCode: string,
    },
};

export function isExternalProviderMetaDataRequisites($: any): $ is ExternalProviderMetaDataRequisites {
    return typeof $ === 'object'
        && $ !== null
        && typeof $.bankName === 'string'
        && typeof $.bankAddress === 'string'
        && typeof $.accountHolderName === 'string';
}

export type ExternalProviderMetaData = {
    supports?: Partial<Record<TransactionChannelType, boolean>>,
    requisites?: ExternalProviderMetaDataRequisites,
};

export enum ExternalFinancialProvider {
    INTERNAL_BANK = 'INTERNAL_BANK', // Internal means that no need in external provider, everything will be processed inside application
    PLATFORM_BANK = 'PLATFORM_BANK', // External microservice but part of platform
    GUAVA = 'GUAVA',
    CLEARJUNCTION = 'CLEARJUNCTION',
}

export type AccountDetail = {
    type: AccountDetailType,
    status: AccountDetailStatus,
    accountNumber: string | null,
    iban: string | null,
    name: string | null,
    walletId: string | null,
    bankCode: string | null,
    swift: string | null,
    providerType: ExternalFinancialProvider | null,
    providersMetadata: ExternalProviderMetaData | null,
    createdDate: Date,
    updatedDate: Date,
};

export type Account = {
    id: number,
    userId: number,
    currencyCode: string,
    type: AccountType,
    label: string | null,

    balance: number,
    balanceFrozen: number,
    balanceOnHold: number,

    totalReceived: number,
    totalSent: number,
    totalFee: number,

    status: AccountStatus,
    details: Array<AccountDetail>,

    createdDate: Date,
    updatedDate: Date,

    card: Array<Card>,

    // addresses: AccountAddress[],
    // accountBalanceHistory: AccountBalanceHistory[],
    // cardCorporateLinks: Promise<CardCorporateLink[]>,
};


